import { createEvent, createStore } from "effector";
import { ToastProps } from "../Toast/types";

export type Toast = ToastProps & {
    /** Time after which toast will automatically removed */
    timer?: number;
};

// effector is state management based on events.
// These events are handled using on() function to modify states.
// reset() function is used to reset the store values with default state.

export const addToast = createEvent<Omit<Toast, "id">>();
export const removeToast = createEvent<number>();
export const removeAllToasts = createEvent();

export const toastStore = createStore<Toast[]>([])
    .on(addToast, (state, toast) => {
        // first get a random id
        const [id] = window.crypto.getRandomValues(new Uint32Array(1));
        // set timeout to remove it after a particular time
        setTimeout(() => removeToast(id), toast.timer || 3000);
        // add toast to state
        return [...state, { ...toast, id }];
    })
    .on(removeToast, (state, id) => state.filter((toast) => toast.id !== id))
    .reset(removeAllToasts);
